<template>
  <Card tag="form" variant="widget" class="residential-mutate-presentation" @submit.prevent="$emit('submit')">
    <template v-if="isNuxt" #header>
      <div class="card-v2__title">{{ $t('presentation') }}</div>
      <FieldBuilder
        :value="layout"
        @input="e => $emit('updateValue', { key: 'themeLayout', value: e, slot: true })"
        :item="builderItem"
        :customFieldSchemas="customFieldSchemas"
        :placement="placement"
        :build="false"
        add-missing
      />
    </template>
    <template #default>
      <div class="residential-mutate-presentation__input">
        <CustomFields
          :value="value"
          @input="e => $emit('updateValue', e)"
          :schema="cfSchemas"
          :data="value"
          :validator="validator"
          :placement="placement"
          :disabledFields="disabledFields"
        >
          <!-- render slots -->
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer
              :validator="validator"
              :item="item"
              :value="value"
              @input="e => $emit('updateValue', { ...e, slot: true })"
            />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'

import Card from '@/components/Card-v2'
import { mapState } from 'vuex'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Residential/StepsFields/FieldRenderer.vue'
import FieldBuilder from '@/components/FieldBuilder'
import { getCustomFieldsWithLayout } from '@/components/FieldBuilder/utils'

const meta = {
  order: 2,
  id: 'presentation',
  label: i18n.tc('presentation'),
  icon: ['fal', 'image'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: { type: Object, default: () => ({}) },
    disabledFields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      placement: ['presentation', 'residential:presentation'],
    }
  },

  computed: {
    ...mapState('Residential', {
      item: state => state.item,
    }),
    theme() {
      return this.$path('item.project.theme')
    },
    //the theme renders the layout -> only Nuxt themes
    isNuxt() {
      return (this.$path('$store.state.enums.NuxtProjects', this) || []).includes(this.theme)
    },

    layout() {
      return this.$path('value.themeLayout') || []
    },
    builderItem() {
      return { ...this.item, theme: this.theme }
    },
    cfSchemas() {
      if (!this.buildLayout) return this.customFieldSchemas
      return getCustomFieldsWithLayout(this.layout, this.customFieldSchemas, this.placement)
    },
  },

  components: {
    Card,
    CustomFields,
    FieldRenderer,
    FieldBuilder,
  },
}
</script>

<style lang="scss">
.residential-mutate-presentation {
  $cols: 6;

  & > .card-v2 {
    &__header {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  &__input {
    display: grid;
    grid-template-columns: repeat($cols, 1fr);
    grid-gap: $form-gap;
  }

  .custom-fields {
    grid-column-end: span $cols;
  }
}
</style>
